import Marionette from 'backbone.marionette';

const template = require('./IframeView.hbs');
import './IframeView.css';

// eslint-disable-next-line max-len
const IframeView = Marionette.LayoutView.extend({
  template,
  className: 'iframe-view',

  templateHelpers() {
    const iframeURL = this.recordModel.getiframeUrl(
        this.layerModel.get('search.iframeUrlTemplate') || undefined
    );
    return {
      iframeURL,
    };
  },

  initialize(options) {
    this.recordModel = options.recordModel;
    this.layerModel = options.layerModel;
  },
});

export default IframeView;



// WEBPACK FOOTER //
// /src/views/IframeView.js